import React from 'react';

import PlpContext from '../../templates/Plp/context';
import TrackedLink from '../TrackedLink';

const Social = () => {
  return (
    <PlpContext.Consumer>
      {({
        plp: { actionUrl = '', customContactNumber = '' } = {},
        template = '',
      } = {}) => (
        <section className="social">
          <div className="social-row">
            <div className="desktop-social">
              <div className="column apply-btn">
                {template !== 'SbaPost' && (
                  <TrackedLink
                    href={actionUrl || '/account/SignUp'}
                    className="button green small app-link apply-button"
                  >
                    Apply Now
                  </TrackedLink>
                )}
              </div>
              <div className="column mobile-phone">
                <h3>
                  <a href="tel:888-986-8263">888-986-8263</a>
                </h3>
              </div>
              <div className="column social-buttons">
                <ul>
                  <li className="facebook">
                    <a href="https://www.facebook.com/KabbageInc">
                      <i className="fa fa-facebook" aria-hidden="true" />
                    </a>
                  </li>
                  <li className="twitter">
                    <a href="https://twitter.com/kabbageinc">
                      <i className="fa fa-twitter" aria-hidden="true" />
                    </a>
                  </li>
                  <li className="linkdin">
                    <a href="http://www.linkedin.com/company/kabbage-inc">
                      <i className="fa fa-linkedin" aria-hidden="true" />
                    </a>
                  </li>
                  <li className="instagram">
                    <a href="https://www.instagram.com/kabbageinc/">
                      <i className="fa fa-instagram" aria-hidden="true" />
                    </a>
                  </li>
                  <li className="youtube">
                    <a href="https://www.youtube.com/channel/UCPD_7-MCjZKxtKLyiUlOCyg">
                      <i className="fa fa-youtube-play" aria-hidden="true" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="column phone">
              <h3>
                <a href={`tel:${customContactNumber || '888-986-8263'}`}>
                  {customContactNumber || '888-986-8263'}
                </a>
              </h3>
            </div>
          </div>
          <div className="clearfix" />
        </section>
      )}
    </PlpContext.Consumer>
  );
};

export default Social;
